import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import './index.css';
import App from './App';
import rootRoutes from './routes';
import 'antd/dist/antd.css';

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <App route={rootRoutes} />
    </ConfigProvider>,
    document.getElementById('root')
);
